import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Button
} from "reactstrap";
import { Textbox,Textarea } from "react-inputs-validation";

  const ListadoProductoFinanciero=({detalleCarrito, handleBack})=> {
  const {   coberturas,
            datosCliente, 
            ingresos, 
            limites, 
            mostrarCobertura
        }=detalleCarrito
    return (
        <Card className="flex-row ">
            <CardBody>
                 <Col  lg={11} md={11} sm={11} xs={11} className="div-align-center">
                    <h4 style={{ fontWeight: "bold", fontSize:"larger" }} className="mb-5"> {`Resumen`}</h4>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >RUC </Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{datosCliente.cedula}</Label></h5>                              
                            </Col>
                        </Col>
                    </Row>                  
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >Nombre de la empresa </Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{datosCliente.nombre}</Label></h5>                              
                            </Col>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >Nombre del solicitante </Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{datosCliente.nombreSolicitante}</Label></h5>
                            </Col>
                        </Col>
                    </Row> */}
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >Provincia</Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{datosCliente.provNombre}</Label></h5>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >Ciudad</Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{datosCliente.ciuNombre}</Label></h5>
                            </Col>
                        </Col>
                    </Row>                                        
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >Direción principal</Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{datosCliente.direccionPrincipal}</Label></h5>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >Facturación Total</Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{ingresos.ingDescripcion}</Label></h5>
                            </Col>
                        </Col>
                    </Row>   
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="bold-font-label" >Giro de Negocio</Label></h5>
                            </Col>
                        </Col>
                        <Col  lg={8} md={8} sm={12} xs={12}>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <h5><Label className="input-type-label  form-control" >{datosCliente.giroNegocio.nombre}</Label></h5>
                            </Col>
                        </Col>
                    </Row> 
                    <hr style={{borderTop: "1px solid"}}></hr>                     
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12} className="mb-5">
                            <h4 style={{ fontWeight: "bold", fontSize:"larger" }}> {`Plan Seleccionado`}</h4>
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <h5 className="text-center"><Label style={{fontSize:"larger"}}>Prima</Label></h5>
                            <h5 className="text-center"><Label>{`$ ${limites.limPrima}`}</Label></h5>
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <h5 className="text-center"><Label style={{fontSize:"larger"}}>Deducible</Label></h5>
                            <h5 className="text-center"><Label>{`$ ${limites.limDeducible}`}</Label></h5>                  
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <h5 className="text-center"><Label style={{fontSize:"larger"}}>Limite Anual</Label></h5>
                            <h5 style={{color:"#af006e"}} className="text-center"><Label>{`$ ${limites.limDescripcion}`}</Label></h5>
                        </Col>
                    </Row>  
                    {mostrarCobertura &&    
                        <div>
                        <hr style={{borderTop: "1px solid"}}></hr>                
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} className="mb-5">
                                <h4 style={{ fontWeight: "bold", fontSize:"larger" }}> {`Coberturas`}</h4>
                            </Col>
                        </Row>
                        { Object.keys(coberturas).length>0 && 
                        coberturas[0].detalleCobertura.map((cobertura, i) => {
                            return (
                                <div>
                                    <Row>
                                        <Col lg={9} md={9} sm={12} xs={12}>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <h5><Label >{`${cobertura.descripcion}`}</Label></h5>
                                            </Col>
                                        </Col>
                                        <Col  lg={3} md={3} sm={12} xs={12}>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <h5 className="text-center"><Label>{`${cobertura.valor}`}</Label></h5>
                                            </Col>
                                        </Col>
                                    </Row>     
                                    <hr ></hr>   
                                </div>
                            );      
                        })
                        }    
                        </div>
                    }
                    <hr style={{borderTop: "1px solid"}}></hr>
                    <Row>
                        <Col> 
                            <Button className="btn btn-detail-gray" onClick={() => handleBack()} style={{ alignSelf:'flex-start', marginTop: "1.8rem" }}  >
                            <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"   REGRESAR"}
                            </Button>
                        </Col>
                    </Row>
                </Col> 
            </CardBody>
        </Card>

    );
  }


export default ListadoProductoFinanciero
